import { createAction } from '@reduxjs/toolkit';

export interface AuthCallbackSuccessPayload {
  accessToken: string;
  idToken: string;
  sessionExpirationTimestamp: number;
}
export interface ProvAuthSuccessPayload {
  sessionTicket: string;
  sessionExpirationTimestamp: number;
  provCustomerToken: string;
}

export const startProvAuth = createAction<undefined>('START_PROV_AUTH');
export const authCallbackSuccess = createAction<AuthCallbackSuccessPayload>('AUTH_CALLBACK_SUCCESS');
export const provAuthSuccess = createAction<ProvAuthSuccessPayload>('PROV_AUTH_SUCCESS');
